import { defineMessages } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/types/entity";

const messages = defineMessages({
  cancel: {
    id: "downloadMultipleEntities.modal.cancel",
    defaultMessage: "Cancel",
    description: "Download entities modal - cancel",
  },
  confirm: {
    id: "downloadMultipleEntities.modal.confirm",
    defaultMessage: "Confirm Download",
    description: "Download entities modal - title",
  },
  download: {
    id: "downloadMultipleEntities.modal.download",
    defaultMessage: "Download",
    description: "Download entities modal - Download",
  },
  [EntityType.ACTIVITY]: {
    id: "downloadMultipleEntities.tab.activities",
    defaultMessage: "Activity",
    description: "Activity Tab",
  },
  [EntityType.COMPANY]: {
    id: "downloadMultipleEntities.tab.companies",
    defaultMessage: "Companies",
    description: "Companies Tab",
  },
  [EntityType.DEAL]: {
    id: "downloadMultipleEntities.tab.deals",
    defaultMessage: "Deals",
    description: "Deals Tab",
  },
  [EntityType.PERSON]: {
    id: "downloadMultipleEntities.tab.people",
    defaultMessage: "People",
    description: "People Tab",
  },
  [EntityType.TRIP]: {
    id: "downloadMultipleEntities.tab.trips",
    defaultMessage: "Drives",
    description: "Drives Tab",
  },
  ok: {
    id: "downloadMultipleEntities.modal.confirmation.ok",
    defaultMessage: "Okay",
    description: "Download entities modal - confirmation ok",
  },
  text: {
    id: "downloadMultipleEntities.modal.collapse.text",
    defaultMessage: "Select Columns",
    description: "Download entities modal - collapse title",
  },
});

export default messages;
